module.exports = __webpack_public_path__ + "img/clock-2.73c91ca7.svg";